/* eslint-disable */
import { MessageBox } from 'element-ui'
import axios from 'axios'
import i18n from '@/lang'

let localSoftwareVersion // html中的/[timestamp]/js/app.[hash].js中的timestamp
let needRefreshPageList = [] // 需要刷新的页面
let timeoutTask = -1

function remindRefresh() {
    clearTimeout(timeoutTask)
    const langObj = {
        en: {
            check_version_refresh_tips: `New features have been released. Please refresh the page to ensure the system runs smoothly`,
            refresh: 'Refresh',
        },
        'zh-Hant': {
            check_version_refresh_tips: '有新功能發布，請重新整理頁面以確保您以後可以順利使用系統',
            refresh: '重新載入',
        },
        'zh-Hans': {
            check_version_refresh_tips: '有新功能发布，请刷新页面以确保您以后可以顺利使用系统',
            refresh: '刷新',
        },
    }
    const lang = langObj[i18n.locale || 'en']
    MessageBox.alert('', lang.check_version_refresh_tips, {
        confirmButtonText: lang.refresh,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false
    }).then(() => {
        location.reload()
    }).finally(() => {})
}

function getLocalVersion() { // 获取本地版本号
    Array.from(document.getElementsByTagName('script')).some(item => {
        const result = item.src.match(/(\d+)\/js\/app\./)
        if (result && result[1]) {
            localSoftwareVersion = result[1]
        }
    })
}

function getRemoteVersion() { // 获取服务器最新版本需要刷新的页面
    if (!localSoftwareVersion) return
    axios.get('/peanut/common/web/publish/queryLatestVersion', {
        params: {
            appName: 'manager-web',
            currentVersionNo: localSoftwareVersion,
        }
    }).then(res => {
        if (res.data && +res.data.code === 200) {
            needRefreshPageList = (res.data.data && res.data.data.pageList) || []
        }
        if (!judgeVersionRemind()) {
            timeoutTask = setTimeout(getRemoteVersion, 40000)
        }
    }).catch(() => {
        timeoutTask = setTimeout(getRemoteVersion, 40000)
    })
}

export function judgeVersionRemind() { // 判断是否弹窗
    if (needRefreshPageList.some(item => location.pathname.startsWith(item))) {
        remindRefresh()
        return true
    }
}


if (process.env.NODE_ENV === 'production') {
    getLocalVersion()
    getRemoteVersion()
}

// localSoftwareVersion = 1760338577183 
// getRemoteVersion()

/* eslint-disable */
